import _objectWithoutProperties from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["caret", "children"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import BorderBox from './BorderBox';
import Caret from './Caret';
import theme from './theme';
function PointerBox(props) {
  // don't destructure these, just grab them
  var bg = props.bg,
    border = props.border,
    borderColor = props.borderColor;
  var caret = props.caret,
    children = props.children,
    boxProps = _objectWithoutProperties(props, _excluded);
  var caretProps = {
    bg: bg,
    borderColor: borderColor,
    borderWidth: border,
    location: caret
  };
  return /*#__PURE__*/React.createElement(BorderBox, _extends({
    sx: {
      position: 'relative'
    }
  }, boxProps), children, /*#__PURE__*/React.createElement(Caret, caretProps));
}
PointerBox.displayName = "PointerBox";
PointerBox.defaultProps = {
  theme: theme
};
export default PointerBox;